import { LitElement, html, css } from 'lit';

class Toaster extends LitElement {
  static properties = {
    bgColor: { type: String },
    width: { type: String },
    height: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    color: { type: String },
    fontSize: { type: String },
    borderRadius: { type: String },
    fontWeight: { type: String },
    progressBarBg: { type: String },
    progressBarHeight: { type: String },
    progressBarColor: { type: String },
    progressBarBorderRadius: { type: String },
    toastMessage: { type: String},
    padding: {type: String}
  };

  constructor() {
    super();
    this.bgColor = 'white';
    this.width = '200px';
    this.height = 'auto';
    this.borderWidth = '1px';
    this.borderColor = 'black';
    this.color = 'black';
    this.fontSize = '14px';
    this.borderRadius = '5px';
    this.fontWeight = 'normal';
    this.progressBarBg = 'white';
    this.progressBarHeight = '5px';
    this.progressBarColor = 'yellow';
    this.progressBarBorderRadius = '5px';
    this.toastMessage = 'Default message';
  }

  static styles = css`
    .progress-container {
      width: 100%;
      height: 5px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
    }
    .toast-container {
      background: white;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      width: 200px;
      padding: 6px 8px;
      border: none !important
    }
    .toast-message {
      font-size: 14px;
      padding: 8px;
    }
    .progress-bar {
      width: 100%;
      height: 100%;
      animation: progress 3s linear forwards;
      transform-origin: left;
    }

    @keyframes progress {
      0% {
        width: 100%;
      }
      100% {
        width: 0%;
      }
    }
  `;

  render() {
    return html`
      <div
        class="toast-container"
        style="background-color: ${this.bgColor}; color: ${this.color}; width: ${this.width}; height: ${this.height}; 
                 border: ${this.borderWidth} solid ${this.borderColor}; 
                 border-radius: ${this.borderRadius}; 
                 font-size: ${this.fontSize};
                 font-weight: ${this.fontWeight};"
      >
        <div class="toast-message" style="padding: ${this.padding}">${this.toastMessage}</div>
        <div class="progress-container" style="height: ${this.progressBarHeight}; border-radius: ${this.progressBarBorderRadius};">
          <div class="progress-bar" style="background-color: ${this.progressBarColor};"></div>
        </div>
      </div>
    `;
  }
}

customElements.define('toast-notification', Toaster);
